<template>
  <BaseSelect :value="value"
              :options="grouped ? account_groups : accounts"
              :select-label="label"
              label="title"
              track-by="id"
              :group-label="grouped ? 'title' : ''"
              :group-values="grouped ? 'childs' : ''"
              :allow-empty="false"
              :searchable="true"
              :show-labels="false"
              :disabled="disabled"
              @input="$emit('input',$event)"
              @open="$emit('open')">
    <template v-slot:noOptions="">
      <div class="w-full whitespace-normal">
        <slot name="noOptions">
          {{ $t('noAccounts') }}
          <router-link :to="{name:'settings-accounts'}" class="text-red">{{ $t('here') }}</router-link>
        </slot>
      </div>
    </template>
    <template v-slot:errors="">
      <slot name="errors"></slot>
    </template>
  </BaseSelect>
</template>
<script>

import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";

export default {
  name: "AccountsSelect",
  components: {BaseSelect},
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      required: true
    },
    grouped: {
      type: Boolean,
      required: true
    },
    accounts: {
      type: Array,
      required: true
    },
    account_groups: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  i18n: {
    messages: {
      en: {
        noAccounts: 'You don\'t have any created accounts yet, you can add them',
        here: 'here'
      },
      ru: {
        noAccounts: 'У вас пока нет сформированных счетов, вы можете добавить их',
        here: 'здесь'
      }
    }
  }
}
</script>